import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AdminLockerReservationTab from './AdminLockerReservationTab'
import AdminLockerManageTab from './AdminLockerManageTab'

type Tab = 'reservations' | 'manage'

export default function AdminLockerPage() {
  const [tab, setTab] = useState<Tab>('reservations')

  const TAB_LIST: { key: Tab; label: string }[] = [
    { key: 'reservations', label: '예약내역' },
    { key: 'manage', label: '금고관리' },
  ]

  return (
    <div className="bg-[#f5f2f0] min-h-screen p-8">
      <div className="max-w-[1200px] mx-auto">

        {/* Header */}
        <div className="mb-6">
          <h1 className="text-[22px] font-extrabold text-[#2a1f1a] mb-1">금고관리</h1>
          <p className="text-[13px] text-gray-400">
            {new Date().toLocaleDateString('ko-KR', {
              year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',
            })}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-5">
          {TAB_LIST.map(t => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-5 py-2 rounded-xl text-[13px] font-semibold transition-colors cursor-pointer border ${
                tab === t.key
                  ? 'bg-[#887267] text-white border-[#887267]'
                  : 'bg-white text-[#5a3d32] border-[#e8e0dc] hover:bg-[#f5f2f0]'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'reservations' && <AdminLockerReservationTab />}
        {tab === 'manage' && <AdminLockerManageTab />}
      </div>
    </div>
  )
}